import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import GlassCard from '../UI/GlassCard';
import Tag from '../UI/Tag';
import SectionHeader from '../UI/SectionHeader';

const capabilities =[
  { id: '01.01', title: 'Frontend ReactJS', desc: 'Building intuitive, high-performing interfaces and analytics dashboards. Focused on clean UI/UX and translating complex requirements into elegant components.', tags: ['ReactJS', 'TypeScript', 'Jest'] },
  { id: '01.02', title: 'Cross-Platform Mobile', desc: 'Engineering robust and scalable mobile applications for iOS and Android using clean architecture principles and efficient state management.', tags: ['Flutter', 'Dart', 'Riverpod'] },
  { id: '01.03', title: 'Backend & Systems', desc: 'Integrating complex backend APIs, customizing modules, and maintaining databases for seamless end-to-end data flow.', tags: ['Node.js', 'PostgreSQL', 'Python / Odoo'] },
];

const Expertise = () => {
  return (
    <Box id="expertise" sx={{ py: 16, position: 'relative' }}>
      <Container maxWidth="lg" sx={{ px: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: { md: 'flex-end' }, justifyContent: 'space-between', gap: 4, mb: 10 }}>
          <SectionHeader number="01" title="Capabilities" description="Core Expertise" />
          <Typography sx={{ color: 'text.secondary', lineHeight: 1.7, maxWidth: '28rem', pb: { md: 2 } }}>
            Translating complex requirements into clean, responsive, and high-performance applications within agile environments.
          </Typography>
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }, gap: 3 }}>
          {capabilities.map((cap) => (
            <GlassCard key={cap.id} sx={{ p: 5, display: 'flex', flexDirection: 'column', height: '100%' }}>
              <Typography sx={{ mb: 4, fontFamily: 'mono', fontSize: '0.75rem', color: 'rgba(0, 240, 255, 0.6)' }}>{cap.id}</Typography>
              <Typography variant="h4" sx={{ fontSize: '1.5rem', fontWeight: 600, mb: 3 }}>{cap.title}</Typography>
              <Typography sx={{ color: 'text.secondary', fontSize: '0.875rem', lineHeight: 1.7, mb: 4 }}>{cap.desc}</Typography>
              <Box sx={{ mt: 'auto', pt: 3, borderTop: '1px solid', borderColor: 'custom.white5', display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {cap.tags.map(tag => <Tag key={tag}>{tag}</Tag>)}
              </Box>
            </GlassCard>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Expertise;